import BaseCrudService from "./baseCrud.service";

export default class CampaignSSOService extends BaseCrudService {

    constructor() {
        super('CampaignSSO');
    }

    saveSSO(campaignSSO){
        return this.postRequest('SaveSSO', campaignSSO)
    }

    getByCampaignId(campaignId){
        return this.getRequest('GetByCampaignId', {campaignId: campaignId});
    }
}